import { render } from "./FilterSummary.vue?vue&type=template&id=971c37e4&scoped=true"
import script from "./FilterSummary.vue?vue&type=script&lang=js"
export * from "./FilterSummary.vue?vue&type=script&lang=js"

import "./FilterSummary.vue?vue&type=style&index=0&id=971c37e4&lang=scss&scoped=true"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971c37e4"]])

export default __exports__